export class Header {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      if (document.getElementById('js-common_header') === null) return
      let header = document.getElementById('js-header')
      let kv = document.querySelector('.p-index_kv')
      let commonHeaderH = document.getElementById('js-common_header').offsetHeight
      let headerH = document.getElementById('js-common_header').offsetHeight
      let kvH = window.innerHeight - (commonHeaderH + headerH) + 40
      kv.style.height = kvH + 'px'
    })
  }
}
